<template>
  <div style="width: 75px; overflow: hidden">
    <button
      type="button"
      data-toggle="modal"
      :data-target="`#registerMateModal${mate.id}`"
    >
      Edit
    </button>

    <section>
      <div class="container">
        <div
          class="modal fade"
          :id="`registerMateModal${mate.id}`"
          tabindex="-1"
          role="dialog"
          aria-labelledby="registerMateModalLabel"
        >
          <div class="modal-dialog" role="document" style="width: 1000px">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" id="myModalLabel">Colleague Details</h4>
              </div>
              <div class="modal-body">
                <section class="section section-sm">
                  <div class="row">
                    <div class="col-md-12">
                      <fieldset class="fieldset-padding">
                        <legend>Personal Details</legend>
                        <div class="row">
                          <div class="col-lg-1 col-sm-12">
                            <label class="font-bold font-8">Title</label>
                            <input
                              v-model="client_details.title"
                              type="text"
                              disabled=""
                            />
                          </div>
                          <div class="col-lg-3 col-sm-12">
                            <label class="font-bold font-8">First Name</label>
                            <input
                              type="text"
                              v-model="client_details.first_name"
                              disabled=""
                            />
                          </div>
                          <div class="col-lg-2 col-sm-12">
                            <label class="font-bold font-8">Middle Name</label>
                            <input
                              type="text"
                              v-model="client_details.middle_name"
                              disabled=""
                            />
                          </div>
                          <div class="col-lg-3 col-sm-12">
                            <label class="font-bold font-8">Family Name</label>
                            <input
                              type="text"
                              v-model="client_details.family_name"
                              disabled=""
                            />
                          </div>
                          <div class="col-lg-3 col-sm-12">
                            <label class="font-bold font-8"
                              >Job Title <span class="required">*</span></label
                            >
                            <input
                              v-model="client_details.job_title"
                              type="text"
                            />
                            <small class="small-font">
                              {{ errors.job_title }}
                            </small>
                          </div>
                          <div class="col-lg-6 col-sm-12">
                            <label class="font-bold font-8">Company</label>
                            <input
                              v-model="client_details.company"
                              type="text"
                              disabled=""
                            />
                          </div>
                          <div class="col-lg-6 col-sm-12">
                            <label class="font-bold font-8"
                              >Address <span class="required">*</span></label
                            >
                            <input
                              v-model="client_details.address"
                              type="text"
                            />
                            <small class="small-font">
                              {{ errors.address }}
                            </small>
                          </div>
                          <div class="col-lg-3 col-sm-12">
                            <label class="font-bold font-8"
                              >Country <span class="required">*</span></label
                            >
                            <select v-model="client_details.country_id">
                              <option
                                v-for="country in countries"
                                :value="country.id"
                                :key="country.id"
                              >
                                {{ country.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-lg-3 col-sm-12">
                            <label class="font-bold font-8"
                              >Email <span class="required">*</span></label
                            >
                            <input
                              v-model="client_details.email"
                              type="text"
                              disabled=""
                            />
                            <small class="small-font">
                              {{ errors.email }}
                            </small>
                          </div>
                          <div class="col-lg-3 col-sm-12">
                            <label class="font-bold font-8">Other E-mail</label>
                            <input
                              v-model="client_details.additional_email"
                              type="text"
                            />
                          </div>
                          <div class="col-lg-3 col-sm-12">
                            <label class="font-bold font-8"
                              >Telephone <span class="required">*</span></label
                            >
                            <input
                              v-model="client_details.telephone"
                              type="text"
                            />
                            <small class="small-font">
                              {{ errors.telephone }}
                            </small>
                          </div>
                          <!-- str nationality -->
                          <div class="col-lg-3 col-sm-12">
                            <label class="font-bold font-8"
                              >Nationality <span class="required">*</span></label
                            >
                            <select v-model="client_details.nationality_id" required>
                              <option
                                v-for="country in countries"
                                :value="country.id"
                                :key="country.id"
                              >
                                {{ country.name }}
                              </option>
                            </select>
                            <small class="small-font">
                              {{ errors.nationality_id }}
                            </small>
                          </div>
                          <!-- end nationality -->
                          <div class="col-lg-3 col-sm-12">
                            <label class="font-bold font-8"
                              >Mobile <span class="required">*</span></label
                            >
                            <input
                              v-model="client_details.mobile"
                              type="text"
                            />
                            <small class="small-font">
                              {{ errors.mobile }}
                            </small>
                          </div>
                          <div class="col-lg-3 col-sm-12">
                            <label class="font-bold font-8"
                              >Name of your Assistant
                            </label>
                            <input
                              v-model="client_details.assistant_name"
                              type="text"
                            />
                          </div>
                          <div class="col-lg-3 col-sm-12">
                            <label class="font-bold font-8"
                              >Assistant's Phone</label
                            >
                            <input
                              v-model="client_details.assistant_phone"
                              type="text"
                            />
                            <small class="small-font">
                              {{ errors.assistant_phone }}
                            </small>
                          </div>
                          <div class="col-lg-3 col-sm-12">
                            <label class="font-bold font-8"
                              >Assistant's E-mail</label
                            >
                            <input
                              v-model="client_details.assistant_email"
                              type="text"
                            />
                            <small class="small-font">
                              {{ errors.assistant_email }}
                            </small>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </section>
              </div>

              <div
                class="modal-footer"
                style="display: flex; justify-content: flex-end"
              >
                <button type="button" class="btn" data-dismiss="modal">
                  Close
                </button>
                <button type="button" @click="submitData" class="btn">
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import joi from "joi";
import _ from "lodash";
import Api from "@/Api";

export default {
  name: "register-mate-modal",
  props: ["mateData", "addMateData", "updateMateData"],
  data() {
    return {
      mate: null,
      errors: {},
      countries: [],
      status: "",
      client_details: {
        first_name: "",
        middle_name: "",
        family_name: "",
        title: "",
        job_title: "",
        company: "",
        address: "",
        country_id: "",
        nationality_id: "",
        email: "",
        // email_confirmation: '',
        additional_email: "",
        telephone: "",
        // fax: '',
        mobile: "",
        assistant_name: "",
        assistant_phone: "",
        assistant_email: "",
      },
    };
  },
  methods: {
    initMateData() {
      this.status = this.mate.status;
      const { client } = this.mate;
      this.client_details = {
        first_name: client.first_name,
        middle_name: client.middle_name,
        family_name: client.family_name,
        title: client.title.name,
        job_title: client.job_title,
        company: client.company.name,
        address: client.address,
        country_id: client.country_id,
        nationality_id: client.nationality_id ? client.nationality_id : 0,
        email: client.email,
        additional_email: client.additional_email,
        telephone: client.telephone,
        mobile: client.mobile,
        assistant_name: client.assistant_name,
        assistant_phone: client.assistant_phone,
        assistant_email: client.assistant_email,
      };
    },

    validate() {
      const schema = joi
        .object({
          job_title: joi
            .string()
            .required()
            .messages({
              "string.empty": '"Job title" is not allowed to be empty',
            }),
          address: joi
            .string()
            .required()
            .messages({
              "string.empty": '"Address" is not allowed to be empty',
            }),
          email: joi
            .string()
            .email({ tlds: { allow: false } })
            .required()
            .messages({ "string.empty": '"Email" data is missing' }),
          telephone: joi
            .string()
            .required()
            .messages({ "string.empty": '"Telephone" data is missing' }),
          nationality_id: joi
            .number()
            .required()
            .$.greater(0).rule({ message: '"Nationality" data is missing' }),
          mobile: joi
            .string()
            .required()
            .messages({ "string.empty": '"Mobile" data is missing' }),
          additional_email: joi
            .string()
            .allow("")
            .email({ tlds: { allow: false } })
            .optional(),
          assistant_email: joi
            .string()
            .allow("")
            .email({ tlds: { allow: false } })
            .optional(),
        })
        .options({ abortEarly: false });

      let keys = _.pick(this.client_details, [
        "job_title",
        "address",
        "email",
        "telephone",
        "nationality_id",
        "mobile",
        "additional_email",
        "assistant_email",
      ]);
      const validation = schema.validate(keys);
      if (validation.error) {
        let err = {};
        let errorsDeatils = validation.error.details.map((error) => {
          err[error.path[0]] = error.message;
          return error;
        });
        this.errors = err;
        return false;
      } else {
        return true;
      }
    },

    submitData() {
      if (this.validate() === true) {
        if (this.status === 2) {
          // registered
          let client = JSON.parse(localStorage.getItem("registeration.client"));

          let mateData = {
            ...this.client_details,
            conf_client_id: this.mate.id,
            updated_by: client.client_id,
          };
          Api()
            .post("auth/update-presenter-mate", mateData)
            .then((res) => {
              this.updateMateData(res.data.client);
              window.$(`#registerMateModal${this.mate.id}`).modal("hide");
            })
            .catch((err) => {
              window.$(`#registerMateModal${this.mate.id}`).modal("hide");
              console.log("err", err);
            });
        } else {
          window.$(`#registerMateModal${this.mate.id}`).modal("hide");
          this.addMateData(this.mate.id, this.client_details);
        }
      }
    },
  },
  created() {
    this.mate = this.mateData;
    this.initMateData();

    //  caling validation here because presenter can select and submit with no need to open modal data
    const isValid = this.validate();
    this.addMateData(
      this.mateData.id,
      this.client_details,
      isValid,
      this.errors
    );

    let lists = JSON.parse(localStorage.getItem("registeration.lists"));
    this.countries = _.orderBy(lists.countries_list, [
      (c) => c.name.toLowerCase(),
    ]);
  },
};
</script>

<style scoped>
.font-bold {
  font-weight: bold;
}

.font-87 {
  font-size: 0.87rem;
}

.font-9 {
  font-size: 0.9rem;
}
.font-8 {
  font-size: 0.8rem;
}

.font-7 {
  font-size: 0.7rem;
}

.small-font {
  font-size: 11px;
  font-weight: bold;
  margin-bottom: 8px;
  color: red;
}
</style>